import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import {OverlayTrigger, Tooltip as Tip} from "react-bootstrap"
import {connect} from "@irati/store"

const Tooltip = ({tip, children, delayShow, placement, showMobile, isPhone}) => {
  const shouldShow = showMobile || !isPhone
  if (tip && shouldShow) {
    return (
      <OverlayTrigger delayShow={delayShow} placement={placement} overlay={tip}>
        {children}
      </OverlayTrigger>
    )
  }

  return children
}

Tooltip.Tip = Tip
export {Tip}

Tooltip.propTypes = {
  placement: PropTypes.string,
  delayShow: PropTypes.number,
  tip: PropTypes.node,
  children: PropTypes.node,
  isPhone: PropTypes.bool.isRequired,
  showMobile: PropTypes.bool
}

Tooltip.defaultProps = {
  placement: "right",
  delayShow: 200,
  tip: null,
  children: null,
  showMobile: true
}

const mapStateToProps = ({mq}) => ({isPhone: get(mq, "lessThan.medium", false)})

export default connect(mapStateToProps)(Tooltip)
